import { Link as Scroll } from 'react-scroll';

/**
 * ページ先頭へ滑らかに戻すスクロールリンク。
 * @returns ページトップリンク
 */
const ToTopScroll = () => {
  return (
    /* 画面上部の共通ヘッダーへスクロールし、長いページでも復帰しやすくする。 */
    <Scroll href='#' to='l-header' smooth duration={100} className='toPageTop'>
      ページトップへ
    </Scroll>
  );
};

export default ToTopScroll;
